var map = {
	"./delete-x.svg": 5614,
	"./edit-pen.svg": 8190,
	"./eye-close-icon.svg": 1778,
	"./eye-open-icon.svg": 7630,
	"./greenhamburgers.svg": 8661,
	"./hamburgers.svg": 8584,
	"./mali-active-mobile.svg": 9757,
	"./mali-inactive-mobile.svg": 2210,
	"./meeting-active-mobile.svg": 6541,
	"./meeting-inactive-mobile.svg": 6594,
	"./profile-active-mobile.svg": 1561,
	"./profile-inactive-mobile.svg": 2166,
	"./record-icon.svg": 3367,
	"./report-active-mobile.svg": 6948,
	"./report-inactive-mobile.svg": 3871,
	"./user-active-mobile.svg": 7955,
	"./user-inactive-mobile.svg": 8196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8098;